import ELocale from '../../../../types/locales'
import { TItem } from '../../types'

const items: TItem[] = [
  {
    label: 'AGB',
    url: {
      [ELocale.DE_DE]: '/dpl/c/service/agb',
      [ELocale.DE_AT]: '/dpl/c/service/agb',
      [ELocale.DE_CH]: '/dpl/c/service/agb',
    },
  },
  {
    label: 'Datenschutz',
    url: {
      [ELocale.DE_DE]: '/dpl/c/service/datenschutz',
      [ELocale.DE_AT]: '/dpl/c/service/datenschutz',
      [ELocale.DE_CH]: '/dpl/c/service/datenschutz',
    },
  },
  {
    label: 'Impressum',
    url: {
      [ELocale.DE_DE]: '/dpl/c/service/impressum',
      [ELocale.DE_AT]: '/dpl/c/service/impressum',
      [ELocale.DE_CH]: '/dpl/c/service/impressum',
    },
  },
]

export { items }
